import React from "react"
import { graphql } from "gatsby"

import { Meta } from "@shared"
import { Footer, GetInTouch, Header, HeroGrid, Investors } from "@components/sections"

import { CONSTANTS } from "@data"
import { logTool } from "@jsUtils"

const { PAGE_NAMES, THEMES, COLORS, PAGE_TRACKER_KEYS, PAGE_TRACKER_VALUES } = CONSTANTS

const log = logTool()

/**
 * Investoors Page
 * @param {object} props - react props
 */
const InvestorsPage = props => {
  const { data } = props
  const { contentfulInvestors, contentfulPageMeta } = data
  log("Investors content:", { contentfulInvestors, contentfulPageMeta })

  return (
    <>
      <Meta
        base={contentfulPageMeta}
        page={contentfulInvestors}
        hubSpotObj={{
          contentTypeKey: PAGE_TRACKER_KEYS.INVESTORS,
          contentTypeValue: PAGE_TRACKER_VALUES.WEBSITE_PAGE
        }}
      />

      <Header theme={THEMES.TIN} pageColor={COLORS.LIGHT} />
      <HeroGrid
        shortHeroSection
        theme={THEMES.TIN}
        color={COLORS.FLURO}
        page={PAGE_NAMES.INVESTORS}
        content={contentfulInvestors}
        classes={
          {
            // headerText: Styles.investorsHeroText
          }
        }
      />
      <Investors data={contentfulInvestors} theme={THEMES.LIGHT} />
      <GetInTouch color={COLORS.FLURO} theme={THEMES.DARK} />
      {/* {isModalEnabledOnSite ? (
        <EmailModal data={contentfulCrmEventBasedModal} theme={THEMES.DARK} color={COLORS.FLURO} />
      ) : null} */}
      <Footer />
    </>
  )
}

/**
 * pageQuery for Investors Page
 */
export const pageQuery = graphql`
  {
    contentfulPageMeta(id: { eq: "423babd8-0278-5b2e-85f6-77fb7ee55bee" }) {
      ...GlobalMetaData
    }
    contentfulCrmEventBasedModal {
      heroImage {
        title
        fluid(quality: 100, maxWidth: 1920) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      supportingText
      heroText
      isModalEnabledOnSite
    }
    contentfulInvestors {
      title
      eyebrow
      headline
      subhead {
        subhead
      }
      pageMeta {
        ...PageMetaData
      }
      investors {
        id
        link
        investorName
        description {
          description
        }
        logo {
          fluid(quality: 100, maxWidth: 1920) {
            ...GatsbyContentfulFluid_withWebp_noBase64
          }
        }
      }
    }
  }
`

export default InvestorsPage
